

import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  mounted () {
    if (this.Tabs.length > 0) {
      this.$router.push(this.Tabs[0].Link as any)
    }
  },
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Items')
    },
    Tabs () {
      var Tabs = [
        { Name: this.Translate('All Items'), Link: '/Reports/Inventory/Items/All', Access: this.Access('Inventory_Items_Read') },
        { Name: this.Translate('Categories'), Link: '/Reports/Inventory/Items/Categories', Access: this.Access('Inventory_Items_Read') },
        { Name: this.Translate('Brands'), Link: '/Reports/Inventory/Items/Brands', Access: this.Access('Inventory_Items_Read') },
        { Name: this.Translate('Available Items'), Link: '/Reports/Inventory/Items/AvailableItems', Access: this.Access('Inventory_Items_Read') }
      ] as Array<CookiesTabs>
      return Tabs.filter(tab => {
        return tab.Access
      })
    }
  },
  methods: {},
  watch: {}
})
